import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {Consts} from "./consts";

const StudyFeedbackPopup = ({ userId, patientRegistrationDate }) => {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [reminderCount, setReminderCount] = useState(0);
  const REMINDER_DAYS_1 = 2 * 7;
  const REMINDER_DAYS_2 = 12 * 7;

  useEffect(() => {
    const currentDate = new Date();
    const reminderDate2 = new Date(patientRegistrationDate);
    reminderDate2?.setDate(reminderDate2?.getDate() + REMINDER_DAYS_2);
    const reminderDate1 = new Date(patientRegistrationDate);
    reminderDate1?.setDate(reminderDate1?.getDate() + REMINDER_DAYS_1);
    let count = 0;

    if (currentDate >= reminderDate2) {
      count = 2;
    } else if (currentDate >= reminderDate1) {
      count = 1;
    }

    const reminderAccepted = localStorage?.getItem(
      getReminderLocalStorageKey(count),
    );

    if (count > 0 && reminderAccepted !== Consts.YES) {
      setShowPopup(true);
    }

    setReminderCount(count);
  }, [patientRegistrationDate]);

  const handleCheckboxChange = () => {
    setDontShowAgain((prev) => {
      const newValue = !prev;

      if (newValue) {
        localStorage?.setItem(getReminderLocalStorageKey(reminderCount), Consts.YES);
      } else {
        localStorage?.removeItem(getReminderLocalStorageKey(reminderCount));
      }

      return newValue;
    });
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const getReminderLocalStorageKey = (count) => {
    return "mmcStudyFeedbackReminderAccepted" + "_" + userId + "_" + count;
  };

  return (
    <div className="w3-modal" style={{ display: showPopup ? Consts.BLOCK : Consts.NONE }}>
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-narrow">
        <header className="w3-container w3-padding-small w3-center">
          <p>{t("study_feedback")}</p>
        </header>
        <div className="w3-container w3-padding-small w3-margin-left">
          <div className="w3-row">
            <label>
              {t("you_are_registered_for_more_than")}{" "}
              {reminderCount === 2 ? t("twelve_weeks") : t("two_weeks")}.
            </label>
            <label>{t("please_give_study_feedback")}.</label>
          </div>
          <div className="w3-row w3-padding-small w3-margin-top">
            <label>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={handleCheckboxChange}
              />{" "}
              {t("do_not_show_again")}
            </label>
          </div>
        </div>
        <footer className="w3-container w3-padding-small">
          <button
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-right"
            onClick={handleClosePopup}
          >
            {t("close")}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default StudyFeedbackPopup;
